<template>
  <div>
    <table-manager @filterChanged="filterChanged"
     @paginationChanged="paginationChanged"
     :options="options"/>
    <basic-table
      v-if="banksFields"
      :items="banks"
      :fields="banksFields"
      :filter="filter"
      :perPage="perPage"

      @RowSelected="rowBankClickHandler"
      v-model="totalRows"
      isEdit="true"/>

      <TableManagerBottom style="margin:5px" id="pagination" ref="pagination"
      :totalRows="totalRows"
      :perPage="perPage"
      @input="changePage"
      v-model="currentPage"/>

      <modal-ok-cancel @save="selectBank" @cancel="hideFormBank"/>
  </div>
</template>

<script>
import TableManagerBottom from '@/components/tables/TableManagerBottom'
export default {
  components: {
    TableManagerBottom
  },
  data () {
    return {
      options: {
        isShowAddButton: false,
        isDisablePerShow: true
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      selectedBank: null,
      banksFields: [
        {key: 'bank_id', label: 'ID'},
        {key: 'bic', label: this.$i18n.t('BIN')},
        {key: 'name', label: this.$i18n.t('Name')},
        {key: 'city', label: this.$i18n.t('City')},
        {key: 'kschet', label: this.$i18n.t('Correspondent account')}
      ]
    }
  },
  methods: {
    changePage (numPage) {
      this.currentPage = numPage
    },
    filterChanged (value) {
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
      this.filter = value
      this.$store.dispatch('ReferenceBooks/GET_BANKS_SEARCH', {
        page: 1,
        value: this.filter,
        per_page: this.perPage
      }).then(el => {
        this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
      })
    },
    async paginationChanged (value) {
      this.perPage = value
      if (this.$refs.pagination) this.$refs.pagination.setCurrentPage(1)
      if (this.currentPage === 1) {
        await this.$store.dispatch('ReferenceBooks/GET_BANKS_SEARCH', {
          page: this.currentPage,
          value: this.filter,
          per_page: this.perPage
        }).then(el => {
          this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
        })
      }
      this.currentPage = 1
    },

    rowBankClickHandler (row) {
      this.selectedBank = row
    },
    selectBank () {
      if (!this.selectedBank) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select Bank'), 'Error')
        return
      }
      this.$emit('selectedBank', this.selectedBank)
      this.hideFormBank()
    },
    hideFormBank () {
      this.$emit('hideFormBank')
    }
  },
  watch: {
    currentPage: async function (val) {
      await this.$store.dispatch('ReferenceBooks/GET_BANKS_SEARCH', {
        page: val,
        value: this.filter,
        per_page: this.perPage
      }).then(el => {
        this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
      })
      this.$refs.pagination.setCurrentPage(val)
    },
    banks: function (val) {
      this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
    }
  },
  computed: {
    banks () {
      return this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].banks
    }
  },
  async mounted () {
    await this.$store.dispatch('ReferenceBooks/GET_BANKS_SEARCH', {
      page: 1,
      value: '',
      per_page: this.perPage
    }).then(el => {
      this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/additional/formBank.vue